import React from "react";
import { Button, Paper, Typography, Stack, Link } from "@mui/material";

const i18n = {
  title: "We value your privacy",
  description:
    "We use cookies and similar technologies to help personalize content, tailor and measure ads, and provide a better experience. By clicking 'Accept', you consent to our use of cookies and tracking technologies.",
  learnMore: "Learn more about our privacy policy",
  accept: "Accept",
  decline: "Decline",
  privacyPolicyUrl: "/privacy-policy",
};

const TrackingConsentBanner = ({ open, onAccept, onDecline }) => {
  if (!open) return null;

  const handleAccept = () => {
    onAccept?.();
  };

  const handleDecline = () => {
    onDecline?.();
  };

  const handleLearnMore = () => {
    window.open(i18n.privacyPolicyUrl, "_blank");
  };

  return (
    <Paper
      elevation={6}
      sx={{
        position: "fixed",
        bottom: { xs: 0, sm: 8 },
        left: { xs: 0, sm: 8 },
        width: { xs: "100%", sm: "50%" },
        zIndex: 1300,
        py: { xs: 2, sm: 4 },
        px: { xs: 3, sm: 6 },
        alignItems: "center",
        justifyContent: "space-between",
        flexWrap: "wrap",
      }}
    >
      <Stack direction={"column"} spacing={1} alignItems={"stretch"}>
        <Typography variant="h6" component="div" sx={{ fontWeight: 600 }}>
          {i18n.title}
        </Typography>
        <Typography variant="body1" color="text.secondary">
          {i18n.description}
        </Typography>
        <Link
          component="button"
          variant="body2"
          onClick={handleLearnMore}
          underline="hover"
          sx={{ textAlign: "left" }}
        >
          {i18n.learnMore}
        </Link>
      </Stack>
      <Stack direction={{ xs: "column", sm: "row" }} spacing={1} sx={{ mt: 2 }}>
        <Button onClick={handleAccept} variant="contained" color="primary">
          {i18n.accept}
        </Button>
        <Button onClick={handleDecline} variant="outlined" color="secondary">
          {i18n.decline}
        </Button>
      </Stack>
    </Paper>
  );
};

export default TrackingConsentBanner;
